import { CopyOutlined } from "@ant-design/icons";
import { Input } from "antd";
import React, { useEffect, useState } from "react";

import { Image, Collapse } from "antd";
import {
  image1,
  image2,
  image3,
  image4,
  image5,
  image6,
  image7,
  image8,
  dashboard1,
  dashboard2,
  wordpress1,
  wordpress2,
  wordpress3,
  // shopify1,
  // shopify2,
  // shopify3,
  // shopify4,
  magento1,
  magento2,
  magento3,
  newshopify2,
  newshopify3,
  newshopify4,
  newshopify5,
  newshopify6,
} from "./CartInstructionsImages";

const { Panel } = Collapse;
const url = window.location.hostname;
const link = `https://${url}`;
const IntegrationStatusCheck = () => (
  <Collapse style={{ marginTop: "1rem" }}>
    <Panel header="How to Check if Integration is Working?" key="1">
      <p>
        1. Log in to{" "}
        <a href={link} target="_">
          {url}
        </a>
      </p>
      <p>
        2. Once logged in, go to the "Profile" in the upper right corner, click
        the dropdown, and select your Organization.
      </p>
      <Image
        width="100%"
        height="100%"
        src={dashboard1}
        style={{ objectFit: "cover" }}
      />
      <p>
        3. On the page that appears, select "Tracking" from the tabs above. You
        can view the "Page Views," "Transactions," and even test the tag you
        created by clicking the "Test Tag" button.
      </p>
      <Image
        width="100%"
        height="100%"
        src={dashboard2}
        style={{ objectFit: "cover" }}
      />
    </Panel>
  </Collapse>
);

const GTMContainerInstallationSteps = ({ tag, handleCopy }) => {
  const images = [
    "",
    image1,
    image2,
    image3,
    image4,
    image5,
    image6,
    image7,
    image8,
  ];

  const steps = [
    `Go to `,
    "Select the GTM container that should already be installed on your website. In this example our website is www.mywebsite.com",
    "Create a new tag by clicking the “Add New Tag” button",
    "Rename the Untitled Tag to Attribution Tag or any preferred name of your choosing",
    "Click on the Tag Configuration and select “Custom HTML”",
    "Click on the HTML sheet and paste the attribution snippet",
    "Set the Trigger to All Pages",
    "Click Save",
    "Click Submit to publish your changes",
  ];
  return (
    <div style={{ padding: "1em" }}>
      {steps.map((step, index) => (
        <React.Fragment key={index}>
          {index === 0 ? (
            <p>
              {`${index + 1}. ${step}`}
              <span>
                <a href="https://tagmanager.google.com/#/home" target="_">
                  tagmanager.google.com
                </a>
              </span>
            </p>
          ) : (
            <>
              <p style={{ marginTop: "1rem" }}>{`${index + 1}. ${step}`}</p>
              {index === 5 ? (
                <Input
                  placeholder="<CopyOutlined />"
                  name="generatedTag"
                  suffix={<CopyOutlined onClick={() => handleCopy(tag)} />}
                  value={tag}
                  style={{ marginBottom: "1em" }}
                />
              ) : null}
              <Image
                alt={`Step ${index + 1}`}
                width="100%"
                height="100%"
                src={images[index]}
                style={{ objectFit: "cover" }}
              />
            </>
          )}
        </React.Fragment>
      ))}
      <p>
        (Optionally. Provide a descriptive name when you submit your changes.)
      </p>
      <IntegrationStatusCheck />
    </div>
  );
};

const MagentoTagInstallationSteps = ({ tag, handleCopy }) => {
  const images = ["", magento1, magento2, magento3, ""];

  const steps = [
    `Log in to Magento`,
    "Go to Content > Click Configuration",
    "On the Configuration click on 'Edit' on your main webstore site",
    "Find HTML Head > Under Scripts and Style Sheets paste the pixel code provided",
    "Click on Save Configuration",
  ];

  return (
    <>
      <div style={{ padding: "1em" }}>
        {steps.map((step, index) => (
          <React.Fragment key={index}>
            <>
              <p style={{ marginTop: "1rem" }}>{`${index + 1}. ${step}`}</p>
              {index === 4 ? (
                <Input
                  placeholder="<CopyOutlined />"
                  name="generatedTag"
                  suffix={<CopyOutlined onClick={() => handleCopy(tag)} />}
                  value={tag}
                  style={{ marginBottom: "1em" }}
                />
              ) : null}
              {images[index] === "" ? null : (
                <Image
                  alt={`Step ${index + 1}`}
                  width="100%"
                  height="100%"
                  src={images[index]}
                  style={{ objectFit: "cover" }}
                />
              )}
            </>
          </React.Fragment>
        ))}
        <IntegrationStatusCheck />
      </div>
    </>
  );
};

//// TODO: OLD SHOPIFY DOCS FOR DISCUSSION NEXT STEPS

// const ShopifyTagInstallationSteps = ({ tag, handleCopy }) => {
//   const images = ["", shopify1, shopify2, "", shopify3, shopify4, ""];

//   const steps = [
//     `Log in to Shopify Store:  `,
//     "Go to Online Store> Themes > Ellipsis (3 dots)> Edit code",
//     "On theme.liquid add the Generated tag before </head>. Then click Save on the upper right.",
//     "For the Additional script, go back to the Shopify homepage and click Settings (bottom part of menu).",
//     "From Settings, go to Checkout and Accounts>Scroll down to Order Status Page and add the second tag to Additional script text box.",
//     "Then click Save on the bottom part of the page.",
//   ];

//   return (
//     <>
//       <div style={{ padding: "1em" }}>
//         {steps.map((step, index) => (
//           <React.Fragment key={index}>
//             {index === 0 ? (
//               <p>
//                 {`${index + 1}. ${step}`}
//                 <span>
//                   <a href="https://www.shopify.com/" target="_">
//                     shopify.com
//                   </a>
//                 </span>
//               </p>
//             ) : (
//               <>
//                 <p style={{ marginTop: "1rem" }}>{`${index + 1}. ${step}`}</p>
//                 {index === 2 ? (
//                   <Input
//                     placeholder="<CopyOutlined />"
//                     name="generatedTag"
//                     suffix={<CopyOutlined onClick={() => handleCopy(tag)} />}
//                     value={tag}
//                     style={{ marginBottom: "1em" }}
//                   />
//                 ) : null}
//                 {images[index] === "" ? null : (
//                   <Image
//                     alt={`Step ${index + 1}`}
//                     width="100%"
//                     height="100%"
//                     src={images[index]}
//                     style={{ objectFit: "cover" }}
//                   />
//                 )}
//               </>
//             )}
//           </React.Fragment>
//         ))}
//         <IntegrationStatusCheck />
//       </div>
//     </>
//   );
// };

const NewShopifyTagInstallationSteps = ({ tag, handleCopy }) => {
  const images = [
    "",
    newshopify2,
    newshopify3,
    "",
    newshopify4,
    newshopify5,
    newshopify6,
  ];

  const steps = [
    `Log in to Shopify Store:  `,
    "Go to Customer Events and Click 'Add Custom Pixel'",
    "Create a name for the Pixel",
    "Copy and Paste the Pixel code",
    "Click on Save and then click Connect",
    "Make sure Pixel is Connected",
  ];

  return (
    <>
      <div style={{ padding: "1em" }}>
        {steps.map((step, index) => (
          <React.Fragment key={index}>
            {index === 0 ? (
              <p>
                {`${index + 1}. ${step}`}
                <span>
                  <a href="https://www.shopify.com/" target="_">
                    shopify.com
                  </a>
                </span>
              </p>
            ) : (
              <>
                <p style={{ marginTop: "1rem" }}>{`${index + 1}. ${step}`}</p>
                {index === 2 ? (
                  <Input
                    placeholder="<CopyOutlined />"
                    name="generatedTag"
                    suffix={<CopyOutlined onClick={() => handleCopy(tag)} />}
                    value={tag}
                    style={{ marginBottom: "1em" }}
                  />
                ) : null}
                {images[index] === "" ? null : (
                  <Image
                    alt={`Step ${index + 1}`}
                    width="100%"
                    height="100%"
                    src={images[index]}
                    style={{ objectFit: "cover" }}
                  />
                )}
              </>
            )}
          </React.Fragment>
        ))}
        <IntegrationStatusCheck />
      </div>
    </>
  );
};

const WooCommerceTagInstallationSteps = ({ tag, handleCopy }) => {
  const images = ["", "", "", wordpress1, wordpress2, "", wordpress3];

  const steps = [
    `Install and activate the `,
    "Go to Snippets → Add New.",
    "Name your snippet (this name is purely internal and helps you remember it).",
    "Paste in the code snippet in the Code box",
    "Scroll down to the bottom of the screen. Choose the Scope for your snippet (when in doubt, stick with the default Run snippet everywhere option). Click Save Changes and Activate",
    "And that’s it! Your snippet is now active.",
    "If you ever need to deactivate or edit the snippet at a later date, you can do that by going to the Snippets → All Snippets area:",
  ];

  return (
    <>
      <div style={{ padding: "1em" }}>
        {steps.map((step, index) => (
          <React.Fragment key={index}>
            {index === 0 ? (
              <p>
                {`${index + 1}. ${step}`}
                <span>
                  <a
                    href="https://wordpress.org/plugins/code-snippets/"
                    target="_"
                  >
                    free Code Snippets plugin
                  </a>
                </span>
              </p>
            ) : (
              <>
                <p style={{ marginTop: "1rem" }}>{`${index + 1}. ${step}`}</p>
                {index === 2 ? (
                  <Input
                    placeholder="<CopyOutlined />"
                    name="generatedTag"
                    suffix={<CopyOutlined onClick={() => handleCopy(tag)} />}
                    value={tag}
                    style={{ marginBottom: "1em" }}
                  />
                ) : null}
                {images[index] === "" ? null : (
                  <Image
                    alt={`Step ${index + 1}`}
                    width="100%"
                    height="100%"
                    src={images[index]}
                    style={{ objectFit: "cover" }}
                  />
                )}
              </>
            )}
          </React.Fragment>
        ))}
        <IntegrationStatusCheck />
      </div>
    </>
  );
};

//Custom HTML Guide(chg) - Will add so that when ThirdParty is chosen from cart, this is displayed for view instructions.
const ThirdpartyTagInstallationSteps = ({ tag }) => {
  // TrackingTab.js line 117 & 219 - replace the script with the baseURL
  // Export from line 295 the tag app id

  const src = tag.split("src=")[1].split(/[ >]/)[0];

  const guide1 = `
        <!DOCTYPE html>;
        <html lang="en">;
        <head>;
        <meta charset="UTF-8">;
        <meta http-equiv="X-UA-Compatible" content="IE=edge">;
        <meta name="viewport" content="width=device-width,initial-scale=1.0">; 
        <script src=${src}></script>;
        <title>Document</title>;
        </head>;
        <body>;
        </body>;
        </html>`;
  const guide2 = `
        window.tracker('trackerAddToCart',
        '000345',               // order ID - string
        'blue tie',             // product name - string
        'clothing',             // category - string
        3.49,                   // unit price - num
        2,                      // quantity - num
        'USD'                   // currency - string
        );
        `;
  const guide3 = `
        window.tracker('trackerRemoveFromCart',
        '000345',               // order ID - string
        'blue tie',             // product name - string
        'clothing',             // category - string
        3.49,                   // unit price - num
        2,                      // quantity - num
        'USD'                   // currency - string
        );
        `;

  const guide4 = `
        // Transaction
        window.tracker('addTrans',
        '1234',                 // order ID - string
        'Acme Clothing',        // affiliation or store name - string
        11.99,                  // total - num
        1.29,                   // tax - num
        5,                      // shipping - num
        'San Jose'              // city - string
        'California'            // state or province - string
        'USA'                   // country - string
        'USD'                   // currency - string
        );
        
        // Transaction Items (items in checkout cart)
        // It is assumed that the "items" variable represents
        // an array of products that comprises the entire
        // checkout
        
        for(let i=0; i < items.length; ++i) {
            window.tracker('addItem',
            '1234',             // order ID - string
            'DD44',             // SKU/code - string
            'T-Shirt',          // product name - string
            'Green Medium',     // category or variation - string 
            11.99,              // unit price - num
            1                   // quantity - num
            'USD'               // currency - string
            );
        }
        window.tracker('trackTrans')
        `;

  const guide5 = `
        window.tracker("trackSelfDescribingEvent", {
        
          schema: "iglu:com.mediajel.events/sign_up/jsonschema/1-0-2",
          
          data: {
              uuid: "1234", // user identifier - string,
              firstName: "john", // user first name - string,
              lastName: "evans", // user last name - string,
              emailAddress: "evans@gmail.com", // email address - string,
              hashedEmailAddress: "evans@gmail.com", // email address - string,
              phoneNumber: "+13056863198" // optional, phone number - string,
          },
          });
        `;

  return (
    <>
      <div style={{ padding: "1em" }}>
        <h2>Ensure our Tracking Pixel is installed on your site’s head tag:</h2>
        <p margintop="1rem">
          Your tracking pixel may look something like this. This is a very
          important step as failure to add our tag on your site’s{" "}
          <a
            href="https://developer.mozilla.org/en-US/docs/Web/HTML/Element/head"
            target="_"
          >
            headers
          </a>{" "}
          will <b>NOT</b> instantiate our attribution SDK. Please note that this
          script should fire on all pages to ensure seamless attribution.
        </p>
        <pre>{guide1}</pre>
        <h2 margintop="1rem">Tracking “Add to Carts”</h2>
        <p>
          Execute this javascript on an add to cart event in your website. The{" "}
          <b>static</b> values below are supposed to represent the variables
          that pertain to the context of data you would pass in programmatically
          from your site. You would swap out the static values with your own
          site’s <b>cart</b> properties during an <b>add to cart</b> event.
        </p>
        <pre>{guide2}</pre>
        <h2 margintop="1rem">Tracking “Remove from carts”</h2>
        <p>
          Execute this javascript on a remove from cart event. The <b>static</b>{" "}
          values below are supposed to represent the variables that pertain to
          the context of data you would pass in programmatically from your site.
          You would swap out the static values with your own site’s <b>cart</b>{" "}
          properties during a <b>remove from cart</b> event.
        </p>
        <pre>{guide3}</pre>
        <h2 margintop="1rem">
          Tracking “Transactions & Transaction Items (Items in cart)”
        </h2>
        <p>
          Execute this javascript on a purchase/checkout event. When a
          checkout/purchase event occurs. You would likely have the transaction
          data as well as the transaction items data. On the addTrans method,
          you would pass in properties relevant to the order itself and on the
          addItem method, you would pass in properties relevant to the items
          that were included in the order.<br></br>
          <br></br>
          You may notice that we have a trackTrans method below. This allows us
          to collect the data for the order & items within that order all at
          once.
        </p>
        <pre>{guide4}</pre>
        <h2 margintop="1rem">Tracking “Signups”</h2>
        <p>
          Execute this javascript on a Sign up event . The <b>static</b> values
          below are supposed to represent the variables that pertain to the
          context of data you would pass in programmatically from your site. You
          would swap out the static values with your own site’s <b>form</b>{" "}
          properties during a <b>Sign up</b> event.
        </p>
        <pre>{guide5}</pre>
        <h2 margintop="1rem">Frequently Asked Questions (FAQ):</h2>
        <p>
          <b>Q:</b> What if I am missing some variables for some methods? (I.E I
          don’t pass in <b>city</b> during a checkout event)<br></br>
          <b>A:</b> You may pass in default values. The default value for string
          types (text) is “<b>N/A</b>” and the default value for <b>num</b>{" "}
          types (numbers) is 0.00. Note however that some arguments are required
          which is listed in the table below:
        </p>
        <table width="100%" border="1px solid black">
          <tbody>
            <tr>
              <th>Method</th>
              <th>Required Arguments</th>
            </tr>
            <tr>
              <th>trackAddtoCart</th>
              <th>ALL</th>
            </tr>
            <tr>
              <th>trackRemoveFromCart</th>
              <th>ALL</th>
            </tr>
            <tr>
              <th>addTrans</th>
              <th>Order Id, total</th>
            </tr>
            <tr>
              <th>addItem</th>
              <th>Order Id, product name, unit price, quantity</th>
            </tr>
          </tbody>
        </table>
        <br></br>
        <p>
          <b>Q:</b> Does the type of data I pass in as arguments matter? (I.E.
          My order ID is an <b>integer</b> whereas the required data type is a{" "}
          <b>string (text)</b>)<br></br>
          <b>A:</b> YES, the data types do matter. We have an enrichment process
          that checks the data that gets sent over to us. The enrichment process
          filters out “bad” data so to make sure the attribution does get
          through the enrichment process, it’d be best to observe the correct
          data types being passed in as arguments based on the above mentioned
          documentation. <br></br>
          There are javascript methods that can convert{" "}
          <a
            href="https://www.w3schools.com/jsref/jsref_parseint.asp"
            target="_"
          >
            string to integers
          </a>{" "}
          and{" "}
          <a
            href="https://www.w3schools.com/jsref/jsref_tostring_number.asp"
            target="_"
          >
            integers to strings
          </a>
          .
        </p>
        <IntegrationStatusCheck />
      </div>
    </>
  );
};

export default function CartInstallation({ cart, tag, handleCopy }) {
  const [renderCart, setRenderCart] = useState(null);

  useEffect(() => {
    setRenderCart(cart);
  }, [cart]);

  const handleRenderCart = () => {
    switch (renderCart) {
      case "SHOPIFY":
      case "SHOPIFYUNIVERSAL":
        return (
          <NewShopifyTagInstallationSteps tag={tag} handleCopy={handleCopy} />
        );
      case "WOOCOMMERCE":
        return (
          <WooCommerceTagInstallationSteps tag={tag} handleCopy={handleCopy} />
        );
      case "THIRDPARTY":
        return (
          <ThirdpartyTagInstallationSteps tag={tag} handleCopy={handleCopy} />
        );
      case "MAGENTO":
        return (
          <MagentoTagInstallationSteps tag={tag} handleCopy={handleCopy} />
        );
      default:
        return (
          <GTMContainerInstallationSteps tag={tag} handleCopy={handleCopy} />
        );
    }
  };

  return (
    <div style={{ height: "70vh", overflow: "auto" }}>{handleRenderCart()}</div>
  );
}
